import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { SheetEditor, toNum } from "@/components/TimesheetUpload";

const toForm = (ts) => ts && ({ operator: ts.operator, date: ts.date || "",
  rows: ts.rows.map((r) => ({ ...r, hours: r.hours ? String(r.hours).replace(".", ",") : "", materials: r.materials || {} })) });

export const TimesheetEditDialog = ({ ts, onClose, onSaved }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => setS(toForm(ts)), [ts]);

  const save = async () => {
    if (!s.operator.trim()) { toast.error("Inserisci il nome dell'operatore"); return; }
    setBusy(true);
    try {
      await api.put(`/admin/timesheets/${ts.id}`, { ...s, photo_id: ts.photo_id || "", rows: s.rows.map((r) => ({ ...r, hours: toNum(r.hours) })) });
      toast.success("Scheda ore aggiornata");
      onSaved(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!ts} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl w-[calc(100%-1rem)] rounded-2xl bg-[#12141A] border-white/10 max-h-[90vh] overflow-y-auto" data-testid="ts-edit-dialog">
        <DialogHeader>
          <DialogTitle>Correggi scheda ore</DialogTitle>
          <DialogDescription>Modifica operatore, data, targhe, ore, lavori e materiali.</DialogDescription>
        </DialogHeader>
        {s && (
          <div className="space-y-3">
            <SheetEditor s={s} i="edit" onChange={setS} />
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onClose} className="rounded-full border-white/15 bg-transparent" data-testid="ts-edit-cancel">Annulla</Button>
              <Button onClick={save} disabled={busy} className="rounded-full bg-[#E63946] hover:bg-[#D62828] text-white" data-testid="ts-edit-save">
                {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}Salva modifiche
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
